module.exports = __webpack_public_path__ + "img/0fa46589f62eca377208e3de43b3b234.png";